import { createAsyncThunk } from '@reduxjs/toolkit';
import { DateTime } from 'luxon';
import { AuditLogAggregations } from 'src/types/auditLogTypes';

export const fetchAggregatedESAuditLogs = createAsyncThunk<
	AuditLogAggregations,
	FetchAggregatedESAuditLogsPayload,
	{ rejectValue: string }
>(
	'auditLogs/fetchAggregatedESAuditLogs',
	async (
		{ api, id, startDate, endDate, searchText, searchField, filters },
		{ rejectWithValue },
	) => {
		const formattedStartDate = startDate
			? DateTime.fromISO(startDate)
					.toUTC()
					.toFormat('yyyy-MM-dd HH:mm:ss')
			: null;

		const formattedEndDate = endDate
			? DateTime.fromISO(endDate).toUTC().toFormat('yyyy-MM-dd HH:mm:ss')
			: null;

		try {
			return await api.getAccountAggregateESAudit(
				id,
				formattedStartDate,
				formattedEndDate,
				searchText,
				searchField,
				filters,
			);
		} catch (error) {
			const message =
				error instanceof Error
					? error.message
					: 'An unexpected error occurred';
			return rejectWithValue(message);
		}
	},
);

type FetchAggregatedESAuditLogsPayload = {
	api: {
		getAccountAggregateESAudit: (
			id: string,
			startDate: string | null,
			endDate: string | null,
			searchText: string,
			searchField: string,
			filters: string[],
			options?: RequestInit,
		) => Promise<AuditLogAggregations>;
	};
	id: string;
	startDate: string | null;
	endDate: string | null;
	searchText: string;
	searchField: string;
	filters: string[];
};
